import type { TemplateChartSeries } from '@/pages/Markets/MarketsComponents/types';

export function getShortTitle(
  templateChartSeries: TemplateChartSeries | undefined
): string | undefined {
  const shortTitle = templateChartSeries?.shortTitle;
  return shortTitle && shortTitle.length > 0 ? shortTitle : undefined;
}
